// Fixture del demo público de Planificaciones (PlanificationDemo.vue).
//
// El contenido pesado (streamText de la planificación, slides, selecciones) vive
// en planificationDemoData.js, que regenera el comando:
//     python manage.py capturar_demo_planificacion
// junto con las imágenes y los archivos descargables en
// public/static/demo-planification/. Ese comando corre una generación REAL del
// producto (gasta tokens de OpenAI + imágenes de Replicate), una sola vez.
//
// Este archivo solo resuelve las rutas de imagen a URL absoluta, porque
// SingleSlideComponent únicamente renderiza <img> cuando el campo empieza con
// "http". No hace ninguna llamada a IA ni backend.

import data from "./planificationDemoData";

// Solo se absolutiza lo que ES una ruta (empieza con "/").
//
// Antes se absolutizaba TODO lo que no empezara con "http", y eso convertía un
// campo mal capturado en una URL falsa. Cuando la captura no alcanza a bajar las
// imágenes, estos campos conservan el prompt con que se generarían; al pegarle
// el origen adelante quedaba "https://misitio.clA calm scene of a capybara…",
// que sí empieza con "http", así que la diapositiva lo daba por bueno, pedía esa
// dirección inexistente y el navegador terminaba mostrando el texto del `alt`
// ("Imagen de despedida") en el lugar de la ilustración. Visto en producción el
// 2026-08-21.
//
// Dejando el prompt intacto no pasa el filtro de SingleSlideComponent, así que
// la lámina simplemente se muestra sin imagen: se ve incompleta, pero no rota.
const abs = (path) =>
  path && path.startsWith("/") ? window.location.origin + path : path;

// Campos que pueden contener una imagen (igual que _process_image_prompts en el
// backend y IMAGE_FIELDS en el comando de captura).
const IMAGE_FIELDS = [
  "promptimage1",
  "promptimage2",
  "promptimage3",
  "promptparaimagen1",
  "promptimagen1",
  "promptimagen2",
  "promptimagen3",
];

const fixture = {
  ...data,
  slides: (data.slides || []).map((slide) => {
    const resolved = { ...slide };
    IMAGE_FIELDS.forEach((field) => {
      if (resolved[field]) resolved[field] = abs(resolved[field]);
    });
    return resolved;
  }),
};

export default fixture;
